import { render, staticRenderFns } from "./tui.vue?vue&type=template&id=3f8424a4&scoped=true&"
import script from "./tui.vue?vue&type=script&lang=js&"
export * from "./tui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8424a4",
  null
  
)

export default component.exports